import { AT } from '../../actions/actionTypes';
import { StateDefault } from './defaults';
import * as CallStatus from '../../utils/callStatus';
import Logger from '../../libs/logger';   import { LogArea } from '../../libs/logger/const';

export default function (state = StateDefault, action: any) {
  switch (action.type) {
    case AT.CONFIG_USER_INFO_RECEIVED: {
      Logger.info(
        [AT.CONFIG_USER_INFO_RECEIVED, action],
        LogArea.Redux
      );
      const tries = 0;
      const updatedOn = undefined;
      return { ...state, tries, updatedOn };
    }

    case AT.CONFIG_UPDATE_CTX_FETCH: {
      Logger.info([AT.CONFIG_UPDATE_CTX_FETCH, action], LogArea.Redux);
      return CallStatus.fetch(state);
    }

    case AT.CONFIG_UPDATE_CTX_SUCCESS: {
      Logger.info([AT.CONFIG_UPDATE_CTX_SUCCESS, action], LogArea.Redux);
      const updatedOn = new Date(Date.now());
      return { ...CallStatus.success(state), updatedOn };
    }

    case AT.CONFIG_UPDATE_CTX_ERROR: {
      Logger.info([AT.CONFIG_UPDATE_CTX_ERROR, action], LogArea.Redux);
      const tries = state.tries + 1;
      return { ...CallStatus.error(state, 'failed to update ctx'), tries };
    }
    default: {
      return state;
    }
  }
}
